
export const COLUMNS = [
  {
    Header: "Unit Number ID	",
    accessor: "id",
  },
  {
    Header: "Unit",
    accessor: "name",
  },
  {
    Header: "No. of Participants",
    accessor: "users_count",
  },
  {
    Header: "Description",
    accessor: "description",
  },
];
